import classNames from 'classnames/bind';
import { motion, Variants } from 'framer-motion';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import styles from './HowWeWorkSection.module.css';

const cx = classNames.bind(styles);

const CardVariants: Variants = {
  offscreen: {
    opacity: 0,
  },
  onscreen: {
    opacity: 1,
    transition: {
      type: 'spring',
      bounce: 0.1,
      duration: 1,
    },
  },
};

function HowWeWorkSection() {
  const { t } = useTranslation('career');
  return (
    <>
      <motion.section
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className={cx('main-wrapper')}
      >
        <motion.div variants={CardVariants}>
          <h1 className={cx('title')}>{t('philosophy')}</h1>
          <div className={cx('image-01')} />
          <h1>
            <Trans
              i18nKey={t('first-philosophy-header')}
              components={{
                br: <br className="disable-mobile-break" />,
              }}
            />
          </h1>
          <h4>
            <Trans
              i18nKey={t('first-philosophy-description')}
              components={{
                br: (
                  <br className="disable-mobile-break disable-tablet-break" />
                ),
              }}
            />
          </h4>
        </motion.div>
      </motion.section>
      <motion.section
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className={cx('main-wrapper')}
      >
        <motion.div variants={CardVariants}>
          <div className={cx('image-02')} />
          <section>
            <h1>
              <Trans
                i18nKey={t('second-philosophy-header')}
                components={{
                  br: (
                    <br className="disable-mobile-break disable-tablet-break" />
                  ),
                }}
              />
            </h1>
            <h4>
              <Trans
                i18nKey={t('second-philosophy-description')}
                components={{
                  br: (
                    <br className="disable-mobile-break disable-tablet-break" />
                  ),
                }}
              />
            </h4>
          </section>
        </motion.div>
      </motion.section>
      <motion.section
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className={cx('main-wrapper')}
      >
        <motion.div variants={CardVariants}>
          <div className={cx('image-03')} />
          <section>
            <h1>{t('third-philosophy-header')}</h1>
            <h4>
              <Trans
                i18nKey={t('third-philosophy-description')}
                components={{
                  br: <br />,
                }}
              />
            </h4>
          </section>
        </motion.div>
      </motion.section>
    </>
  );
}

export default HowWeWorkSection;
